// extracted by mini-css-extract-plugin
export var cardLayout = "_24-1";
export var paginationContainer = "_24-0";